





































import { Component, Vue } from "vue-property-decorator";
@Component
export default class Home extends Vue {
  public year: any = null;
  public month: any = null;
  public day: any = null;
  public currentYear: any = null;
  public currentMonth: any = null;
  public currentDay: any = null;
  public yearList: any = [];
  public monthList: any = [];
  public dayList: any = [];
  public created() {
    this.getDate();
    this.initYearList();
  }
  public initYearList() {
    // 获取日期
    const myDate = new Date();
    this.currentYear = myDate.getFullYear(); // 获取当前年
    this.currentMonth = myDate.getMonth() + 1; // 获取当前月
    this.currentDay = myDate.getDate(); // 获取当前日
    this.initSelectYear(this.currentYear);
    this.initSelectMonth(this.currentYear, this.currentMonth);
    this.initSelectDay(this.currentYear, this.currentMonth);
  }
  // 获取年份
  public initSelectYear(year) {
    this.yearList = [];
    for (let i = 0; i <= year - Number(year - 100); i++) {
      this.yearList.push({ value: year - i, label: year - i + "年" });
    }
  }
  // 获取月份
  public initSelectMonth(year, month) {
    this.monthList = [];
    let len;
    if (this.year === year) {
      len = month;
    } else {
      len = 12;
    }
    for (let i = 1; i <= len; i++) {
      this.monthList.push({ value: i, label: i + "月" });
    }
  }
  // 获取天数
  public initSelectDay(year, month) {
    this.dayList = [];
    const maxDay = this.getMaxDay(this.year, this.month);

    let len;
    if (this.year === year && this.month === month) {
      len = this.currentDay;
    } else {
      len = maxDay
    }
    for (let i = 1; i <= len; i++) {
      this.dayList.push({ value: i, label: i + "日" });
    }
  }
  // 年月日截取
  public getDate() {
    const birthday = this.$store.state.user.info.birthday_time;
    if (birthday != "" && birthday != null) {
      this.year = Number(birthday.substring(0, 4));
      this.month = Number(birthday.substring(5, 7));
      this.day = Number(birthday.substring(8, 10));
    }
  }
  public getMaxDay(year, month) {
    let newYear = year; // 取当前的年份
    let newMonth = month++; // 取下一个月的第一天，方便计算（最后一天不固定）
    if (month > 12) {
      // 如果当前大于12月，则年份转到下一年
      newMonth -= 12; // 月份减
      newYear++; // 年份增
    }
    const newDate = new Date(newYear, newMonth, 1); // 取当年当月中的第一天
    return new Date(newDate.getTime() - 1000 * 60 * 60 * 24).getDate(); // 获取当月最后一天日期
  }
  public dateChange() {
    this.initSelectMonth(this.currentYear, this.currentMonth)
    this.initSelectDay(this.currentYear, this.currentMonth);
    if (this.monthList.length < this.month) {
      this.month = this.day = 1;
    }
    if (this.dayList.length < this.day) {
      this.day = 1;
    }
  }
  public selectDate() {
    const birthday = `${this.year}-${this.month}-${this.day}`;
    this.$emit("selectDate", birthday);
  }
}
